import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const ONLINE_USERS_URL = `${BASE_URL}/usernameSearch`;
export const ONLINE_USERS_TAGGS_URL = `${BASE_URL}/directoryCams`;
export const ONLINE_USERS_ATTRIBUTES_URL = `${BASE_URL}/directoryCams`;
